export const awsAsset = (assetName, pack, ext) => {
  return `https://cdn-serviceshift.s3.amazonaws.com/production/assets/${pack}/${assetName}.${ext}`;
};
